import LandingDarkScope from "@/components/LandingDarkScope";
import MarketingSiteChrome from "@/components/MarketingSiteChrome";

export default function LegalPageLayout({ title, lastUpdated, children }) {
  return (
    <LandingDarkScope>
      <MarketingSiteChrome contentClassName="max-w-[900px] mx-auto px-4 md:px-8">
        <div className="text-overline">Aivory EMS</div>
        <h1 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight mt-2">{title}</h1>
        {lastUpdated ? (
          <p className="text-sm text-[var(--text-tertiary)] mt-3">
            <strong className="text-[var(--text-secondary)] font-medium">Last Updated:</strong> {lastUpdated}
          </p>
        ) : null}
        <div className="mt-8 pb-4">{children}</div>
      </MarketingSiteChrome>
    </LandingDarkScope>
  );
}
